<template>
  <div
    class="mt-2 flex text-xs italic"
    style="color: var(--neutral-0)">
    <div class="mr-1">{{ $t("message.lastUpdated") }}:</div>
    <div class="">
      {{ lastUpdated }}
    </div>
  </div>
</template>

<script>
const props = {
  lastUpdated: {
    type: String,
    required: true,
  },
};

export default {
  props,
};
</script>

<style>
.embed-last-updated {
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.1px;
  text-align: right;
}
</style>
